import PropTypes from 'prop-types';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Routes, Route, useNavigate } from "react-router-dom";
import { layoutTypes } from "./constants/layout";
import './assets/css/style.css'
// Import Routes all
import { authProtectedRoutes, participantsRoutes, publicRoutes, raterRoutes, } from "./routes";
import { GoogleOAuthProvider } from "@react-oauth/google";


// Import all middleware
import Authmiddleware from "./routes/route";

// layouts Format
import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

// Import scss
import "./assets/scss/theme.scss";
import "toastr/build/toastr.min.css";
import { checkAuthType } from 'store/actions';
import checkType from 'helpers/jwt-token-access/checkType';
import NotFound from "pages/Starter/pages-404"


const getLayout = (layoutType) => {
  let Layout = VerticalLayout;
  switch (layoutType) {
    case layoutTypes.VERTICAL:
      Layout = VerticalLayout;
      break;
    case layoutTypes.HORIZONTAL:
      Layout = HorizontalLayout;
      break;
    default:
      break;
  }
  return Layout;
};

const App = () => {
  const navigate = useNavigate();
  const currentPath = window.location.pathname;
  const dispatch = useDispatch()
  const { layoutType, authType } = useSelector((state) => ({
    layoutType: state.Layout.layoutType,
    authType: state?.CheckAuthType?.authType,
  }));
  const clientId = "315592021987-op0ucdp74buh84mnj1a2pufm4t8gv6e0.apps.googleusercontent.com";
  const Layout = getLayout(layoutType);

  useEffect(() => {
    const number = localStorage.getItem('number');
    const checkAuth = localStorage.getItem('authUser');

    if (checkAuth) {
      let role = JSON.parse(number)

      if (currentPath === "/" || currentPath === "/admin/login") {
        navigate("/dashboard");
      }

      if (currentPath === "/" || currentPath === "/participant/login") {
        navigate("/dashboard");
      }
      if ((currentPath === "/" && role == 60) || (currentPath === "/rater/login" && role == 60)) {
        navigate("/save-servey");
      }

    }

  }, [])

  return (
    <React.Fragment>
      <GoogleOAuthProvider clientId={clientId}>
        <Routes>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={
                <NonAuthLayout>
                  {route.component}
                </NonAuthLayout>
              }
              key={idx}
              exact={true}
            />
          ))}

          {
            checkType() === 'admin'
              ?
              authProtectedRoutes.map((route, idx) => (
                <Route
                  path={route.path}
                  element={
                    <Authmiddleware>
                      <Layout>{route.component}</Layout>
                    </Authmiddleware>}
                  key={idx}
                  exact={true}
                />
              ))
              : checkType() === 'participant'
                ?
                participantsRoutes.map((route, idx) => (
                  <Route
                    path={route.path}
                    element={
                      <Authmiddleware>
                        <Layout>{route.component}</Layout>
                      </Authmiddleware>}
                    key={idx}
                    exact={true}
                  />
                ))
                :
                raterRoutes.map((route, idx) => (
                  <Route
                    path={route.path}
                    element={
                      <Authmiddleware>
                        <Layout>
                          {route.component}
                        </Layout>
                      </Authmiddleware>}
                    key={idx}
                    exact={true}
                  />
                ))}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </GoogleOAuthProvider>
    </React.Fragment>
  );
};

App.propTypes = {
  layout: PropTypes.any
};

export default App;